import React, { FC } from 'react';

import { BUTTON_TYPES, EvConfirm } from '@evinced-private/ui-common';

import { SITE_SCANNER_APP_ID } from '../../../../consts/dom-consts';
import { ICollection } from '../../../../interfaces/Collection';
import { useCollections } from '../../../../providers/collections/CollectionsProvider';

interface IDeleteCollectionPopup {
	/**
	 * Collection data
	 */
	collection: ICollection;
	/**
	 * AccessibilityProps is used to pass accessibility attributes into the trigger button
	 */
	accessibilityProps?: unknown;
}

const maxNameLength = 18;

export const DeleteCollectionPopup: FC<IDeleteCollectionPopup> = ({
	collection,
	accessibilityProps
}) => {
	const { removeCollection, isCollectionUpdating } = useCollections();

	const { name } = collection;
	const title =
		name.length > maxNameLength
			? `Delete “${`${name.slice(0, maxNameLength)}...“`}?`
			: `Delete “${name}”?`;

	const onConfirmDelete = async (): Promise<void> => {
		await removeCollection(collection);
	};

	return (
		<EvConfirm
			appElement={SITE_SCANNER_APP_ID}
			title={title}
			approveButtonText="Delete Collection"
			onConfirm={onConfirmDelete}
			promptMessage="Deleting this collection will not delete its properties. You cannot undo this action."
			triggerButtonProps={{
				type: BUTTON_TYPES.GHOST,
				title: 'Delete collection',
				children: 'Delete collection',
				accessibilityProps
			}}
			isBgTransparent={true}
			isPopupLoading={isCollectionUpdating}
		/>
	);
};
